// extracted by mini-css-extract-plugin
export default {"wrapper":"booking_reports_page-module___wrapper___e99113a3"};